import { createSelector } from '@reduxjs/toolkit';

const selectCommunicationTemplateEntries = (state) =>
    state.entities.communicationService.communicationTemplates;

export const selectSortedCommunicationTemplates = createSelector(
    selectCommunicationTemplateEntries,
    (communicationTemplates) => {
        const newTemplates = [...communicationTemplates];
        return newTemplates.length > 0
            ? newTemplates.sort((a, b) => a.name.trim().localeCompare(b.name.trim()))
            : [];
    }
);
